import LineChartRenderer from './lineChartRenderer';
import ScatterChartRenderer from './scatterChartRenderer';
import BarChartRenderer from './barChartRenderer';
import HorizontalBarChartRenderer from './horizontalBarChartRenderer';
import AxesRenderer from './axesRenderer';
import { ChartSchema } from '../../../types/types';

// Export all renderers
export { LineChartRenderer, ScatterChartRenderer, BarChartRenderer, HorizontalBarChartRenderer, AxesRenderer };

// Chart renderer factory
export const getChartRenderer = (chartType: string) => {
  switch (chartType.toLowerCase()) {
    case 'line':
    case 'area':
      return LineChartRenderer;
    case 'scatter':
    case 'outlier':
      return ScatterChartRenderer;
    case 'bar':
      return BarChartRenderer;
    case 'horizontal-bar':
      return HorizontalBarChartRenderer;
    default:
      return LineChartRenderer; // Default to line chart
  }
};
